import { Action } from "redux";
import { IdentityProfile } from "../model";

export const GET_PROFILE = "GET_PROFILE";

export interface GetProfileAction extends Action<string> {
    profile: IdentityProfile
}
